module.exports = __webpack_public_path__ + "img/17.d9c8f92b.png";